import { generatePath } from 'react-router-dom'
import {
  ORDERS,
  ORDERS_CREATE,
  ORDERS_INFO,
  ORDERS_CANCEL,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestOrdersList = async (page, filters) => {
  const params = page > 1 ? { params: { page, ...filters } } : { params: filters }

  return request.get(ORDERS, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestOrderCreate = async (params) => (
  request.post(ORDERS_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestOrderInfo = async (id) => {
  const path = generatePath(ORDERS_INFO, { id })

  return request.get(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestOrderCancel = async (id) => {
  const path = generatePath(ORDERS_CANCEL, { id })

  return request.delete(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
